// extracted by mini-css-extract-plugin
export default {"snackbar":"UpdateNotification_snackbar__3i2W9","alert":"UpdateNotification_alert__vDW+v"};